var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"channel-badge-status",class:_vm.badgeClasses},[_vm._v("\n  "+_vm._s(_vm.statusText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }